// Files that cannot import this constant repeat the name as a literal:
// index.html, public/manifest.json, and public/maintenance-vylor.html.
export const PRODUCT_NAME = "Research Chat";

// Prefix for downloaded file names, e.g. "research-chat-my-thread-2026-10-07.json".
export const PRODUCT_FILE_PREFIX = PRODUCT_NAME.toLowerCase().replace(
  /\s+/g,
  "-"
);
